/** Opciones tipoUsuario para LoginSISPRO (MinSalud) */
export const OPCIONES_TIPO_USUARIO_SISPRO = [
    { value: 'RE', label: 'RE — Representante Entidad' },
    { value: 'PIN', label: 'PIN — Profesional Independiente Nacional' },
    { value: 'PINx', label: 'PINx — Profesional Independiente Nacional de Excepción' },
    { value: 'PIE', label: 'PIE — Profesional Independiente Extranjero' },
];

export const TIPO_USUARIO_SISPRO_DEFAULT = 'PIN';
